<template>
  <div>
    <div class="all-promo-info-name">
      <div class="flex items-center gap-2">
        <h3 class="text-heading-1 text-beige-90 inline font-semibold!">
          {{ item.name }}
        </h3>
        <RfButtonNew
          type="plain"
          size="none"
          :disabled="userStore.isDisabledWithMessage || locked"
          @click="showSegmentNameDialog"
        >
          <RfEditIcon class="h-6! w-6!" />
        </RfButtonNew>
      </div>
      <div>{{ item.description }}</div>
    </div>
    <RfEditModal
      v-if="!userStore.isReadOnly || !locked"
      ref="editModalRef"
      title="Segment's Name and Description"
      @confirm="submitConfiguration"
    />
  </div>
</template>

<script>
import RfEditModal from "@/components/modals/RfEditModal.vue";
import { cloneDeep } from "lodash-es";
import { useSegmentStore } from "@/pinia/segmentStore";
import { useUserStore } from "@/pinia/userStore";
import RfButtonNew from "../buttons/RfButtonNew.vue";
import RfEditIcon from "../icons/RfEditIcon.vue";

export default {
  name: "RfSegmentName",
  components: { RfEditModal, RfButtonNew, RfEditIcon },
  props: ["item", "locked"],
  setup: () => ({ segmentStore: useSegmentStore(), userStore: useUserStore() }),
  methods: {
    showSegmentNameDialog() {
      this.$refs.editModalRef?.open({ name: this.item.name, description: this.item.description });
    },
    async submitConfiguration({ name, description }) {
      const newSegment = { ...cloneDeep(this.item), name, description };
      await this.segmentStore
        .update({
          appId: this.$route.params.aid,
          segId: this.$route.params.sid,
          modelSegment: newSegment,
        })
        .catch(() => null);
    },
  },
};
</script>
